module.exports = __webpack_public_path__ + "static/img/nothin.09a278e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nothin.png
// module id = xq3/
// module chunks = 0